import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class KeepDeserted2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.KEEP_DESERTED2;
}

export default KeepDeserted2PoiTileEntity;
